import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { YoutubePlayerComponent, YoutubePlayerVars } from '@teamfoster/sdk/youtube-player';

@Component({
    selector: 'app-youtube-dialog',
    imports: [YoutubePlayerComponent],
    templateUrl: './youtube-dialog.component.html',
    styleUrl: './youtube-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeDialogComponent {
  private store = inject(Store);
  data = inject(MAT_DIALOG_DATA);

  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);

  youtubeConfig: YoutubePlayerVars = {
    modestbranding: 1,
    autoplay: 1,
  };
}
